import { InvoiceApi } from './apis/invoice-api';
import { JobsApi } from './apis/jobs-api';
import { ClientsApi } from './apis/clients-api';
import { TimeoffApi } from './apis/timeoff-api';
import { ReportsApi } from './apis/reports-api';
import { EmployeeApi } from './apis/employee-api';
import { TimesheetApi } from './apis/timesheet-api';
import { ProjectApi } from './apis/project-api';
import { LocaleApi } from './apis/locale-api';
import { AddressApi } from './apis/address-api';
import { WorkflowApi } from './apis/workflow-api';
import { ContactinfoApi } from './apis/contactinfo-api';
import { NotificationsApi } from './apis/notifications-api';
import { InvoiceApiWrapper } from '../api/InvoiceApiWrapper';
import { WorkflowApiWrapper } from '../api/WorkflowApiWrapper';
import { getApiKey } from 'components/authentication/context/authContext';
import { Configuration } from './configuration';
declare global {
  interface Window {
    customEncodeURIComponent: (param: any) => string;
  }
}
window.customEncodeURIComponent = function (param) {
  return encodeURIComponent(param instanceof Date ? param.toISOString() : String(param));
};
export type Settings = {
    URL: string,
    CLIENT_ID: string,
    LOGIN_DOMAIN: string,
    REDIRECT_URL: string,
    RESPONSE_TYPE: string,
    URL_ADDRESS: string,
    URL_CLIENTS: string,
    URL_CONTACTINFO: string,
    URL_EMPLOYEE: string,
    URL_INVOICE: string,
    URL_JOBS: string,
    URL_LOCALE: string,
    URL_NOTIFICATIONS: string,
    URL_PROJECT: string,
    URL_REPORTS: string,
    URL_TIMEOFF: string,
    URL_TIMESHEET: string,
    URL_WORKFLOW: string,
    USER_POOL_ID: string,
    URL_WSS_NOTIFICATIONS: string,
}
export default class Api{
    public invoiceApi: InvoiceApi;
    public invoiceApiWrapper: InvoiceApiWrapper;
    public workflowApiWrapper: WorkflowApiWrapper;
    public jobsApi: JobsApi;
    public clientsApi: ClientsApi;
    public timeoffApi: TimeoffApi;
    public reportsApi: ReportsApi;
    public employeeApi: EmployeeApi;
    public timesheetApi: TimesheetApi;
    public projectApi: ProjectApi;
    public localeApi: LocaleApi;
    public addressApi: AddressApi;
    public workflowApi: WorkflowApi;
    public contactinfoApi: ContactinfoApi;
    public notificationsApi: NotificationsApi;
    constructor(settings: Settings)
    {
        this.invoiceApi = new InvoiceApi(new Configuration({apiKey: getApiKey}), settings.URL_INVOICE);
        this.invoiceApiWrapper = new InvoiceApiWrapper(this.invoiceApi);
        this.jobsApi = new JobsApi(new Configuration({apiKey: getApiKey}), settings.URL_JOBS);
        this.clientsApi = new ClientsApi(new Configuration({apiKey: getApiKey}), settings.URL_CLIENTS);
        this.timeoffApi = new TimeoffApi(new Configuration({apiKey: getApiKey}), settings.URL_TIMEOFF);
        this.reportsApi = new ReportsApi(new Configuration({apiKey: getApiKey}), settings.URL_REPORTS);
        this.employeeApi = new EmployeeApi(new Configuration({apiKey: getApiKey}), settings.URL_EMPLOYEE);
        this.timesheetApi = new TimesheetApi(new Configuration({apiKey: getApiKey}), settings.URL_TIMESHEET);
        this.projectApi = new ProjectApi(new Configuration({apiKey: getApiKey}), settings.URL_PROJECT);
        this.localeApi = new LocaleApi(new Configuration({apiKey: getApiKey}), settings.URL_LOCALE);
        this.addressApi = new AddressApi(new Configuration({apiKey: getApiKey}), settings.URL_ADDRESS);
        this.workflowApi = new WorkflowApi(new Configuration({apiKey: getApiKey}), settings.URL_WORKFLOW);
        this.workflowApiWrapper = new WorkflowApiWrapper(this.workflowApi);
        this.contactinfoApi = new ContactinfoApi(new Configuration({apiKey: getApiKey}), settings.URL_CONTACTINFO);
        this.notificationsApi = new NotificationsApi(new Configuration({apiKey: getApiKey}), settings.URL_NOTIFICATIONS);
    }
}